module.exports = __webpack_public_path__ + "static/super-single-1c2c3e7a79a6fb1fecd89c90cdf6423c.png";